import { assert } from '@varos/util-typescript';
import { ChatLoaderBaseConfig } from '../../../../base';
import { MessageSolutionContextItemLoader } from './solutionContextInterface';
import { MessageSolutionContextItemAggregate } from './solutionContextModel';

export function createMessageSolutionContextItemLoader(
    config: ChatLoaderBaseConfig
): MessageSolutionContextItemLoader {
    const { repository } = config;

    return {
        useLoad(context, props): MessageSolutionContextItemAggregate {
            const integrationToolQuery = repository.platform.integrationTool.useRetrieve(
                context,
                props.item.data.solutionId,
                {
                    suspense: true,
                    staleTime: Infinity,
                }
            );
            assert(integrationToolQuery.status === 'success', 'expected suspense');
            return {
                solution: integrationToolQuery.data,
            };
        },
    };
}
